"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // Nav
    'landing.nav.about': 'About',
    'landing.nav.modules': 'Modules',
    'landing.nav.assistants': 'AI Assistants',
    'landing.nav.contentStudio': 'Content Studio',
    'landing.nav.analytics': 'Analytics',
    'landing.nav.login': 'Sign in',
    'landing.hero.eyebrow': 'AI Platform for Business',
    'landing.hero.title1': 'One dashboard.',
    'landing.hero.title2': 'All AI models',
    'landing.hero.title3': 'of your business.',
    'landing.hero.lede': 'IntHub brings together GPT-5, Claude, Gemini and DeepSeek in one place — along with assistants, content planning, cost reports and team management. No switching between a dozen tools.',
    'landing.hero.ctaLogin': 'Sign in to the panel',
    'landing.hero.ctaModules': 'See modules',
    'landing.hero.note': 'testhub.intgate.io — panel available for logged-in companies',
    'landing.hero.deviceTitle': 'Start talking to your AI assistant',
    'landing.hero.deviceSub': 'Choose a model, writing style and connect knowledge — with one command.',
    'landing.hero.deviceInput': '/ style · # project · @ knowledge — type your question…',
    'landing.model.openai': 'OpenAI · GPT-5',
    'landing.model.claudeSonnet': 'Claude Sonnet 4.6',
    'landing.model.deepseek': 'DeepSeek V3.2',
    'landing.model.gemini': 'Gemini 3.5 Flash',
    'landing.model.claudeHaiku': 'Claude Haiku 4.5',
    'landing.intro.eyebrow': 'Introduction',
    'landing.intro.title': 'Command center for AI across your entire organization',
    'landing.intro.lede1': 'Instead of scattering work across dozens of tabs, IntHub gathers AI model conversations, virtual assistants, content planning and cost reports into one system. Each company operates in its own space — with its own users, roles, credit budget and set of models.',
    'landing.intro.lede2': 'The system is multi-tenant from the ground up: one admin account can handle multiple companies, industries and teams, and every database operation is recorded in an audit log.',
    'landing.stat.providers': '4 providers',
    'landing.stat.providersLab': 'OpenAI, Anthropic, DeepSeek, Google — one chat interface',
    'landing.stat.roles': '3 roles',
    'landing.stat.rolesLab': 'Super Admin, Manager, User — precise permissions',
    'landing.stat.multitenant': 'Multi-tenant',
    'landing.stat.multitenantLab': 'Multiple companies, industries and teams in one system',
    'landing.stat.credits': 'Credits',
    'landing.stat.creditsLab': 'AI usage billing in a transparent subscription model',
    'landing.modules.eyebrow': 'Modules',
    'landing.modules.title': 'What exactly you\'ll find in IntHub',
    'landing.modules.lede': 'Nine modules, one login. Each one covers a different stage of working with AI in your business — from conversation to billing.',
    'landing.module.chat.title': 'Multi-model AI Chat',
    'landing.module.chat.desc': 'Chat with GPT-5, Claude, Gemini or DeepSeek from one window. Use "/" to switch writing style, "#" to connect a project, and "@" for knowledge — no tab switching.',
    'landing.module.assistants.title': 'Virtual Assistants',
    'landing.module.assistants.desc': 'Create avatars with their own personality, gender and AI model. Each goes through a training task list and gets its own knowledge base before starting work.',
    'landing.module.knowledge.title': 'Knowledge Base',
    'landing.module.knowledge.desc': 'Connect company documents and data to a specific assistant or project, so answers stick to your company\'s facts, not generalities.',
    'landing.module.contentStudio.title': 'Content Studio',
    'landing.module.contentStudio.desc': 'Plan posts, assign channels and track status from draft to publication. AI assistant suggests topics, content plans and best publishing times.',
    'landing.module.styles.title': 'Writing Styles',
    'landing.module.styles.desc': 'Save your brand\'s voice — from formal, like professional correspondence, to youth slang — and share it with the whole team with one toggle.',
    'landing.module.costs.title': 'Cost Reports',
    'landing.module.costs.desc': 'Track tokens, cost per message and most active avatars broken down by user, company and selected period — with a live trend chart.',
    'landing.module.management.title': 'Company & Team Management',
    'landing.module.management.desc': 'Run multiple companies with separate modules, industries and professions. Assign Super Admin, Manager and User roles to each account.',
    'landing.module.logs.title': 'Audit Logs & Access',
    'landing.module.logs.desc': 'Every creation and update of a conversation, message or currency rate goes into the database log — with full view of input data and operation result.',
    'landing.module.pricing.title': 'Plans & Payments',
    'landing.module.pricing.desc': 'From a free plan to Ultra with no limits — users, avatars and features grow with your business, billed in monthly credits.',
    'landing.assistants.eyebrow': 'AI Assistants',
    'landing.assistants.title': 'A bot team that grows with your business',
    'landing.assistants.lede': 'Each assistant is a separate AI employee: their own model, personality, gender and scope of knowledge. A historian answers differently than an accounting assistant — because you teach them separately, with a training task list.',
    'landing.assistants.feature1': 'Any model for any avatar — Claude, DeepSeek, Gemini',
    'landing.assistants.feature2': 'Training task list before going to work',
    'landing.assistants.feature3': 'Own knowledge base and list or grid view of assistants',
    'landing.avatar.historian': 'Historian',
    'landing.avatar.historianRole': 'Claude Sonnet 4.6',
    'landing.avatar.hive': 'HIVE Assistant',
    'landing.avatar.hiveRole': 'DeepSeek V3.2 · Developer',
    'landing.avatar.communicator': 'Communicator',
    'landing.avatar.communicatorRole': 'Gemini 3.5 Flash',
    'landing.avatar.whatsapp': 'Whatsapp',
    'landing.avatar.whatsappRole': 'Claude Haiku 4.5',
    'landing.avatar.statusConfig': 'Configuration complete',
    'landing.cs.eyebrow': 'Content Studio',
    'landing.cs.title': 'From idea to publication, no spreadsheets needed',
    'landing.cs.lede': 'The post library shows what\'s a draft, what\'s awaiting approval, and what\'s already live. Ask the AI assistant for a topic, a weekly plan or the best time to publish — it responds based on your library.',
    'landing.cs.feature1': 'Statuses: draft, scheduled, pending approval, published',
    'landing.cs.feature2': 'Schedule and publication history in one place',
    'landing.cs.feature3': 'AI assistant suggests topics based on engagement',
    'landing.cs.statScheduled': 'Scheduled (7 days)',
    'landing.cs.statApproval': 'Pending approval',
    'landing.cs.statPublished': 'Published (30 days)',
    'landing.cs.statTotal': 'Total posts',
    'landing.cs.postTitle': 'Testing the API',
    'landing.cs.postStatus': 'Published',
    'landing.cs.postContent': '"Hi! Today we show you how to test an API step by step. Perfect for beginner developers…"',
    'landing.cs.suggest1': 'What topics will bring the best engagement?',
    'landing.cs.suggest2': 'Suggest a content plan for next week',
    'landing.cs.suggest3': 'When is the best time to publish?',
    'landing.analytics.eyebrow': 'Analytics',
    'landing.analytics.title': 'Every token accounted for down to the penny',
    'landing.analytics.lede': 'Filter cost reports by date, user, avatar or company. See total cost, token count, average cost per message and which avatar generates the most traffic — with a trend chart over time.',
    'landing.analytics.feature1': 'Filters by date, user, avatar and company',
    'landing.analytics.feature2': 'Cost and token trend chart over time',
    'landing.analytics.feature3': 'Most active avatar ranking in the organization',
    'landing.analytics.totalCost': 'Total cost',
    'landing.analytics.tokens': 'Tokens',
    'landing.analytics.messages': 'Messages',
    'landing.analytics.avgCost': 'Avg. cost / message',
    'landing.analytics.topMessages': 'Top avatar messages',
    'landing.analytics.topAvatar': 'Top avatar',
    'landing.management.eyebrow': 'Management & security',
    'landing.management.title': 'Multi-company structure, control at every level',
    'landing.management.lede': 'One installation handles multiple companies, industries and professions — and every change in the database is recorded before anyone asks "who changed this?".',
    'landing.management.companies.title': 'Companies, users, roles',
    'landing.management.companies.desc': 'Add companies with NIP, address and assigned modules. Assign each account a role — Super Admin, Manager or User — plus a group and a parent user.',
    'landing.management.logs.title': 'Database audit logs',
    'landing.management.logs.desc': 'Filter logs by date, model and operation type. For each entry you can see exact input data and results — useful for cost accounting and diagnosing errors.',
    'landing.management.table.company': 'Company',
    'landing.management.table.city': 'City',
    'landing.management.table.status': 'Status',
    'landing.management.table.model': 'Model',
    'landing.management.table.operation': 'Operation',
    'landing.management.table.date': 'Date',
    'landing.management.company1': 'Studio Nord Sp. z o.o.',
    'landing.management.company2': 'Kancelaria Wschód',
    'landing.management.company3': 'Biuro Rachunkowe Miller',
    'landing.management.warsaw': 'Warsaw',
    'landing.management.krakow': 'Kraków',
    'landing.management.elk': 'Ełk',
    'landing.management.active': 'Active',
    'landing.management.opConversation': 'Conversation',
    'landing.management.opMessage': 'Message',
    'landing.management.opCurrency': 'Currency rate',
    'landing.management.opCreate': 'Create',
    'landing.management.opUpdate': 'Update',
    'landing.cta.eyebrow': 'Ready to launch',
    'landing.cta.title': 'Centralize AI in your business today',
    'landing.cta.lede': 'Sign in to the test panel and configure your first assistant in minutes.',
    'landing.cta.button': 'Go to login',
    'landing.footer.copyright': '© 2026 IntHub. All rights reserved.',
    'landing.footer.panel': 'Login panel',
    'landing.img.logo': 'IntHub',
    'landing.img.bg1': 'Workstation with AI',
};
